import React from 'react';
import ReportFrame from '../ReportFrame';

export default class AssignmentDetailsLite extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Assignment Details Lite'
          reportParams={reportParams}
          id='AssignmentDetailsLite'
          name='AssignmentDetailsLite'
          title='Assignment Details Lite'
        />
      </div>
    );
  }
}
